import { withSideNavigationAnalyticsListener } from '../../analytics/context';
import { type NavItemConfig } from '../../types';
import { useNavAnalytics } from '../use-nav-analytics';

export function useModifyNavItemForAnalytics() {
	const { fireViewSideNavSubMenuEvent, fireClickedSideNavSubMenuItemEvent } = useNavAnalytics();

	function modifyNavItemForAnalytics(
		id: string,
		item: NavItemConfig,
		isInMore?: boolean,
	): NavItemConfig {
		let newItem = { ...item };
		switch (item.type) {
			case 'expand': {
				const onExpansionToggle = (isExpanded: boolean) => {
					item.onExpansionToggle?.(isExpanded);
					if (isExpanded) {
						fireViewSideNavSubMenuEvent(id, undefined, isInMore);
					}
				};

				// Wrap children with our analytics listener to capture their click events
				const wrappedChildren = withSideNavigationAnalyticsListener(item.children, () =>
					fireClickedSideNavSubMenuItemEvent(id, undefined, isInMore),
				);
				newItem = { ...item, onExpansionToggle, children: wrappedChildren };
				break;
			}
			case 'flyout': {
				const onFlyoutOpenChange = (isOpen: boolean) => {
					item.onOpenChange?.(isOpen);
					if (isOpen) {
						fireViewSideNavSubMenuEvent(id, undefined, isInMore);
					}
				};

				// Wrap children with our analytics listener to capture their click events
				const wrappedChildren = withSideNavigationAnalyticsListener(item.children, () =>
					fireClickedSideNavSubMenuItemEvent(id, undefined, isInMore),
				);

				newItem = { ...item, onOpenChange: onFlyoutOpenChange, children: wrappedChildren };
				break;
			}
			case 'object-list-flyout': {
				const subItemsCount = item
					.useItems('', [])
					.sections?.flatMap((section) => section.items)?.length;
				const onOpenChange = (isOpen: boolean) => {
					item.onOpenChange?.(isOpen);
					if (isOpen) {
						fireViewSideNavSubMenuEvent(id, subItemsCount, isInMore);
					}
				};

				// Callback to handle click events on sub-menu items
				const onSubMenuItemClick = () =>
					fireClickedSideNavSubMenuItemEvent(id, subItemsCount, isInMore);

				newItem = { ...item, onOpenChange, onSubMenuItemClick };
				break;
			}
		}
		return newItem;
	}
	return { modifyNavItemForAnalytics };
}
